<template>
  <div class="rota-shift-assigned-to-view">
    <font-awesome-icon
      v-if="getCurrentShift"
      :icon="getIconClasses"
      class="me-2"
    />
    <span class="current-name">
      <template v-if="getCurrentShift">
        <user-display-resolver
          :user-id="getCurrentShift?.userId"
          :agency-id="getCurrentShift?.agencyId"
          :display-name="getCurrentShift?.displayName"
        />
      </template>
      <template v-else> (No one at the moment) </template>
    </span>
    <div v-if="getHistoricalAssignments">
      <ul class="shift-assignments">
        <li
          v-for="(assignment, index) in getHistoricalAssignments"
          :key="index"
        >
          <span v-if="assignment.type === 'holiday'">
            <font-awesome-icon icon="umbrella-beach" fixed-width class="me-1" />
            On Holiday:
          </span>
          <span v-else-if="assignment.type === 'sick'">
            <font-awesome-icon
              icon="temperature-high"
              fixed-width
              class="me-1"
            />
            Off Sick:
          </span>
          <span v-else>
            <font-awesome-icon icon="user-slash" fixed-width class="me-1" />
            {{ assignment.type }}:
          </span>
          {{ assignment.displayName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import defaultTo from "lodash/defaultTo";
import filter from "lodash/filter";
import findLast from "lodash/findLast";
import has from "lodash/has";
import { formatModifiedDate } from "../../../lib/date-functions";
import UserDisplayResolver from "@/components/UserDisplayResolver.vue";

export default {
  name: "RotaShiftAssignedtoViewForAgenda",
  components: {
    UserDisplayResolver,
  },
  props: {
    assignedTo: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  setup() {
    return {
      formatModifiedDate,
    };
  },
  data() {
    return {};
  },
  computed: {
    getCurrentShift() {
      return defaultTo(findLast(this.assignedTo, { type: "current" }), null);
    },
    getHistoricalAssignments() {
      const historicalAssignments = filter(
        this.assignedTo,
        (assignment) => assignment.type !== "current",
      );
      if (historicalAssignments.length > 0) {
        historicalAssignments.reverse();
        return historicalAssignments;
      }
      return null;
    },
    isAgency() {
      const currentShift = this.getCurrentShift;
      return currentShift && has(currentShift, "agencyId");
    },
    getIconClasses() {
      return ["fas", this.isAgency ? "id-card" : "user"];
    },
  },
};
</script>

<style>
ul.shift-assignments {
  list-style: none;
}
</style>
